import { createStyles, makeStyles } from "@material-ui/core/styles"
import axios, { AxiosError } from "axios"
import { useEffect, useState } from "react"
import { useNavigation } from "../../hooks/useNavigation"
import { colors } from "../../utils/theme"
import { PrimaryButton } from "../atoms/button/Button"
import Input from "../atoms/input/Input"
import Logo from "../atoms/Logo"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) =>
  createStyles({
    loginContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      backgroundColor: colors.primary.cloud,
    },
    form: {
      width: "100%",
      maxWidth: 360,
      padding: theme.spacing(3),
    },
    input: {
      marginBottom: theme.spacing(2),
    },
    loginButton: {
      marginTop: theme.spacing(2),
    },
    logo: {
      marginBottom: theme.spacing(4),
    },
    errorText: {
      color: "red",
      textAlign: "center",
      marginBottom: theme.spacing(2),
    },
  })
)

const DeleteAccountLogin = () => {
  const classes = useStyles()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [emailError, setEmailError] = useState<string | undefined>(undefined)
  const [passwordError, setPasswordError] = useState<string | undefined>(
    undefined
  )
  const [flashMessage, setFlashMessage] = useState<string | undefined>("")

  useEffect(() => {
    const message = localStorage.getItem("flashMessage")
    if (message) {
      setFlashMessage(message)
      localStorage.removeItem("flashMessage")
    }
  }, [])

  const { toDeleteAccountConfirmation } = useNavigation()
  const handleLogin = async () => {
    setEmailError(undefined)
    setPasswordError(undefined)
    setError("")
    if (!email || !password) {
      setEmailError("Please enter your email to continue")
      setPasswordError("Please enter your password to continue")
      return
    }

    const mobileLoginEndpoint = `${process.env.REACT_APP_VIRA_AUTHN_APIM_ENDPOINT}/login`
    try {
      // Adjust URL to your mobile login endpoint
      const response = await axios.post(mobileLoginEndpoint, {
        email,
        password,
      })
      console.log("user data: ", response.data.user.default_role)
      if (response.data.user.default_role !== "user") {
        setError("User not found.")
        return {
          error: "",
          message: "User not found.",
          statusCode: 400,
        }
      }
      const data = response.data
      if (data.jwt_token) {
        const userId = data.user.id
        localStorage.setItem("userId", userId)
        localStorage.setItem("jwt", data.jwt_token)
        toDeleteAccountConfirmation()
      } else {
        setError("Login failed. Please try again.")
      }
    } catch (error) {
      const axiosError = error as AxiosError
      setError("An error occurred during login.")
      console.log("Error:", error)
      if (axiosError.response) {
        console.log("Response received:", axiosError.response)
      } else if (axiosError.request) {
        console.log("No response received:", axiosError.request)
      } else {
        console.log("Error", axiosError.message)
      }
    }
  }

  return (
    <BaseTemplate>
      <div
        onKeyDown={async (event) => {
          if (event.key === "Enter") {
            await handleLogin()
          }
        }}
      >
        <Logo className={classes.logo} />
        {flashMessage && (
          <div className={classes.errorText}>{flashMessage}</div>
        )}{" "}
        {/* Display the flash message here */}
        <div className={classes.form}>
          {error && <div className={classes.errorText}>{error}</div>}
          <Input
            type="email"
            label="Email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={classes.input}
            error={Boolean(emailError)}
            helperText={emailError || ""}
          />
          <Input
            type="password"
            label="Password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={classes.input}
            error={Boolean(passwordError)}
            helperText={passwordError || ""}
            enableShowPassword={true}
          />
          <PrimaryButton onClick={handleLogin} className={classes.loginButton}>
            Log In to Delete Account
          </PrimaryButton>
        </div>
      </div>
    </BaseTemplate>
  )
}

export default DeleteAccountLogin
